import { post, get } from "./http/platformServer";

/** 获取当前登录的京东店铺Token */
export function getEncrytionToken(shopId: number, config?) {
    return post<{ encryptedToken: string }>(shopId, "/jd/security/get_jd_encrypted_token", {}, config);
}

/** 获取当前登录的京东店铺一次性Token */
export function getOnceToken(shopId: number, componentId: string) {
    return get<{ onceToken: string }>(shopId, "/jd/security/get_once_token", { componentId }, { hideModal: true });
}
